export default __webpack_public_path__ + "static/media/dashboard.5b9cbcfb.svg";